import React from 'react';
import { Icon } from './Icon.js';
export const IconDiamondSparkle = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M6 3L2 9L12 21L22 9L18 3H6Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M13.5234 9.47656L12 8.78409V8.21591L13.5234 7.52344L14.2159 6H14.7841L15.4766 7.52344L17 8.21591L17 8.78409L15.4766 9.47656L14.7841 11H14.5H14.2159L13.5234 9.47656Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconDiamondSparkle.js.map